import * as React from "react";

import { cn } from "@/lib/utils";

interface AnchoredTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  contentClassName?: string;
  side?: "top" | "bottom" | "left" | "right";
  align?: "start" | "center" | "end";
}

const sideClasses: Record<NonNullable<AnchoredTooltipProps["side"]>, Record<NonNullable<AnchoredTooltipProps["align"]>, string>> = {
  top: {
    start: "bottom-full left-0 mb-2",
    center: "bottom-full left-1/2 mb-2 -translate-x-1/2",
    end: "bottom-full right-0 mb-2",
  },
  bottom: {
    start: "top-full left-0 mt-2",
    center: "top-full left-1/2 mt-2 -translate-x-1/2",
    end: "top-full right-0 mt-2",
  },
  left: {
    start: "right-full top-0 mr-2",
    center: "right-full top-1/2 mr-2 -translate-y-1/2",
    end: "right-full bottom-0 mr-2",
  },
  right: {
    start: "left-full top-0 ml-2",
    center: "left-full top-1/2 ml-2 -translate-y-1/2",
    end: "left-full bottom-0 ml-2",
  },
};

export function AnchoredTooltip({
  children,
  content,
  className,
  contentClassName,
  side = "top",
  align = "center",
}: AnchoredTooltipProps) {
  return (
    <span className={cn("group relative inline-flex", className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          "pointer-events-none absolute z-[1200] w-max max-w-[min(24rem,calc(100vw-1.5rem))] rounded-md border border-neutral-200 bg-white px-3 py-1.5 text-sm text-neutral-800 shadow-lg opacity-0 transition-opacity duration-150 ease-out whitespace-normal break-words",
          "group-hover:opacity-100 group-focus-within:opacity-100",
          sideClasses[side][align],
          contentClassName,
        )}
      >
        {content}
      </span>
    </span>
  );
}
